"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Styled = __importStar(require("./Checkbox.styled"));
var checkbox_active_12_svg_1 = __importDefault(require("@/assets/svg/checkbox-active-12.svg"));
var Checkbox = function (_a) {
    var handleToggle = _a.handleToggle, _b = _a.disabled, disabled = _b === void 0 ? false : _b, isChecked = _a.isChecked, _c = _a.label, label = _c === void 0 ? '' : _c, resetProps = __rest(_a, ["handleToggle", "disabled", "isChecked", "label"]);
    return ((0, jsx_runtime_1.jsxs)(Styled.CheckboxWrapper, __assign({}, resetProps, { disabled: disabled }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", onChange: handleToggle, checked: isChecked }, void 0), (0, jsx_runtime_1.jsx)(Styled.CheckboxMark, { children: (0, jsx_runtime_1.jsx)(checkbox_active_12_svg_1.default, {}, void 0) }, void 0), label && (0, jsx_runtime_1.jsx)(Styled.CheckboxText, { children: label }, void 0)] }), void 0));
};
exports.default = Checkbox;
